import React, { useState,useEffect }  from 'react';
import Icon, {DownOutlined,HolderOutlined, UserOutlined,MenuUnfoldOutlined,MenuFoldOutlined} from '@ant-design/icons';
import { Layout, Menu,Dropdown, Space,Breadcrumb, Avatar,Button } from 'antd';
import {Route, Routes, NavLink} from "react-router-dom"
import { useLocation } from 'react-router'
// import { withRouter} from "react-router-dom"
// import './styles.less';
import './index.css';
import menuList from '../../menuRoute/index';
import { localStorageSet,localStorageGet } from '../../utils/global.js';

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;

const ExitSvg = () => (
  <svg t="1672717209068" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13765" width="16" height="16"><path d="M951.737186 488.212224 802.424532 301.56936c-7.222495-9.027607-18.034748-14.011108-29.157064-14.011108-4.131087 0-8.300037 0.688685-12.349259 2.106987-14.957667 5.246491-24.970718 19.371186-24.970718 35.223223l0 111.98756-298.631448 0c-41.232077 0-74.656327 33.42425-74.656327 74.656327 0 41.2331 33.42425 74.656327 74.656327 74.656327l298.631448 0 0 111.98756c0 15.852036 10.013051 29.977755 24.970718 35.223223 4.049223 1.424442 8.218172 2.108011 12.349259 2.108011 11.123338 0 21.934568-4.978385 29.157064-14.013155l149.311631-186.643887C962.64563 521.221012 962.64563 501.848803 951.737186 488.212224L951.737186 488.212224zM586.628698 810.162774 362.66074 810.162774l-74.656327 0 0-0.011256c-0.199545 0-0.393973 0.011256-0.587378 0.011256-40.906665 0-74.076112-33.42425-74.076112-74.656327l0-74.656327 0-298.631448 0-74.656327 0.011256 0c0-0.199545-0.011256-0.393973-0.011256-0.587378 0-40.906665 33.429367-74.076112 74.66349-74.076112l74.656327 0 223.967958 0c41.2331 0 74.66349-33.422204 74.66349-74.656327 0-41.232077-33.429367-74.656327-74.66349-74.656327L213.340923 63.586201c-82.459037 0-149.311631 66.853617-149.311631 149.311631l0 597.262896c0 82.4662 66.853617 149.311631 149.311631 149.311631l373.286752 0c41.2331 0 74.66349-33.422204 74.66349-74.656327C661.291165 843.586001 627.861798 810.162774 586.628698 810.162774L586.628698 810.162774zM586.628698 810.162774" fill="currentColor" p-id="13766"></path></svg>);
  
const ExitIcon = props => (
  <Icon component={ExitSvg} {...props} />
  );


const scrheight = document.body.clientHeight;
// console.log(scrheight)

var PathBASE=window.location.href;
// console.log('PathBASE -------- ', PathBASE);
    PathBASE = PathBASE.split("#/")[0]; 
// console.log('PathBASE -------- ', PathBASE);

const Admin =(props)=>{

  // const navigate = useNavigate();
  const [curMenu, setCurMenu] = useState("order");
  const [curTitle, setCurTitle] = useState(["工单管理"]);
  const [collapsed, setCollapsed] = useState(false);
  // const [openKeys, setOpenKeys] = useState([]);
  // const onOpenChange = (keys) => {
  //   console.log(keys, keys)
  //   // const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
  //   // if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
  //   //   setOpenKeys(keys);
  //   // } else {
  //   //   setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  //   // }
  // };

  const token = localStorage.getItem('token_k');
  var currentUserinfo = localStorageGet('UserInfo_k');
  console.log("token---------", token);
  console.log("currentUserinfo---------", currentUserinfo);

  if(!token || !currentUserinfo)
    window.location.href=PathBASE+'#/login';

  const location = useLocation();
  console.log('location:------------------ ', location)

  useEffect(() => {
    setCurMenu(location.pathname);
    const title = getTitle(menuList,location.pathname);
    console.log('=========title============',title)
    setCurTitle(title);

    if(currentUserinfo.roleid != 99){
      // 非超级管理查看路径权限
      var mymenus = JSON.parse(currentUserinfo.menus);
      if(!mymenus.includes(location.pathname)){
        var goto = "/dashboard";
        if(!mymenus.includes("/dashboard")){
          if(mymenus.includes("/order"))
            goto = "/order";
          else
            goto = mymenus[0];
        }
        window.location.href=PathBASE+'#'+goto;
      }
    }else{
      if(title.length==0)
        window.location.href=PathBASE+'#/dashboard';
    }
  }, [location.pathname]);


  const getTitle=(list,path)=>{
    console.log('list----------',list)
    console.log('path----------',path)
    var titleList = [];
    //得到当前请求路径
    for(let i=0;i<list.length;i++){
      let item = list[i];
      console.log('item----------',item)
      console.log(path.substring(0, item.path.length))
      if(path == item.path){
        titleList.push(item.title);
        break;
      }
      else if(path.substring(0, item.path.length) == item.path){
        titleList.push(item.title);
        if(item.children){
          for(let j=0;j<item.children.length;j++){
            let item_c = item.children[j];
            // console.log('item_c----------',item_c)
            if(path == item_c.path){
              titleList.push(item_c.title);
              break;
            }
          }
        }
      }
    }
      // console.log('titleList------',titleList)
    return titleList
  }

const getRoutesNodes=(menuList)=>{
  return menuList.map(item=>{        
      if(!item.children || item.children.length==0){
          return <Route path={item.path} key={item.path+1}  element={item.component}></Route>
      }else{
          return  getRoutesNodes(item.children)
      } 
  })
}

const getMenuaNodes=(menuList)=>{
  // console.log('menuList ---------------- ', menuList)
  // console.log(menuInfo)
  console.log("menuList - currentUserinfo---------", currentUserinfo);
  console.log(typeof(currentUserinfo.menus))
  const menus = Array.isArray(currentUserinfo.menus)? currentUserinfo.menus : JSON.parse(currentUserinfo.menus);
  // console.log("menuList - ---------", menus);
  for(let v of menus){
    var a = v.split("/")
    if(a.length>2)
      menus.push("/"+a[1]);
  }
  // console.log("menuList2 - ---------", menus);

  return menuList.map(item=>{
    // console.log('item----------', item);
    //如果当前用户有item权限，才需要显示对应菜单项
    // if(item.show ){
    if(currentUserinfo.roleid=='99' || menus.includes(item.path)){
      if(!item.children || item.children.length == 0){
              return(<Menu.Item key={item.path} icon={item.icon}>
                  <NavLink to={item.path}> {item.title}</NavLink>                      
                  </Menu.Item>)
      }else{
          return(
              <SubMenu key={item.path} icon={item.icon} title={item.title}>
                  {getMenuaNodes(item.children)}
              </SubMenu>
          )
      }
    }
  })
}

  const onClick = ({ key }) => {
    // message.info(`Click on item ${key}`);
    if(key == "logout")
      Logout();
  };
  const items = [
    {
      label: <Space align="center" size={12}><ExitIcon />退出登录</Space>,
      key: 'logout',
      // icon: <ExitIcon />
    },
  ];

  const Logout = (e) => {
    localStorage.setItem('token_k',"");
    localStorageSet("UserInfo_k", {});
    window.location.href=PathBASE+'#/login';
  }

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout>
    <Header 
    style={{
        position: 'fixed',
        top: 0,
        zIndex: 800,
        width: '100%',
        height:50,
        background:"rgb(21,72,152)",
        color:"white"
      }}
       className="header" theme="light" >
      <div style={{margin: '-9px -30px',minHeight: 40,position:"absolute"}}>
        <img src={[require(collapsed?"../../img/logo.png":"../../img/logo2.png")]} height={40}/>
        <Button
          type="text"
          onClick={toggleCollapsed}
          style={{
            color:"white",
          }}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
      </div>
      <div  className="top-right" >
      {/* <Button type="normal"  shape="round" className='msgbutton' icon={<BellOutlined style={{ fontSize: '20px'}}/>} ></Button> */}
      <Dropdown className='userSuper'
        menu={{
          items,
          onClick,
          style:{borderRadius:10,textAlign:"center"}
        }}
      >
        <a onClick={(e) => e.preventDefault()}>
          {/* <Space align="center" style={{color:"black"}}> */}
            {/* <img src={[require("../../img/avatar.png")]} width={25} style={{borderRadius:"50%"}} /> */}
            <Avatar size="middle" icon={<UserOutlined />} />
            <span style={{marginLeft:10,marginRight:15}}>{currentUserinfo.account}</span>
            <DownOutlined style={{fontSize:10}} />    
          {/* </Space> */}
        </a>
      </Dropdown>
    </div>
    </Header>
    <Layout theme="light">
      <Sider width={200} className="site-layout-background"  collapsed={collapsed} collapsedWidth={60}
        style={{
          marginTop: 50,
          paddingTop: 20,
          height: scrheight-50,
          overflowY: "scroll",
          // minHeight: scrheight-50,
          // maxHeight: scrheight-50,
          position: "fixed"
        //   padding: '10px 10px',background:'#f1f6fa',
        //   overflow: 'auto',
        //   // height: '90vh',
        //   position: 'fixed',
        //   left: 0,
        //   top: 65,
        //   bottom: 5,
        }}
        >
        <Menu 
        theme="dark" 
        mode="inline" 
        defaultSelectedKeys={[curMenu]} 
        selectedKeys={[curMenu]} 
        // openKeys={openKeys}
        // onOpenChange={onOpenChange} 
        // style={{fontSize:15, backgroundColor:"rgb(21,72,152)", color:"white", marginLeft:200}}
      >
        {getMenuaNodes(menuList, {})}
      </Menu>

      </Sider>
      
      <Layout theme="light"
        style={{
          // marginTop:80, marginRight:20, marginBottom:10, marginLeft:collapsed?60:20,
          marginTop:60, marginRight:10, marginBottom:10, marginLeft:collapsed?60:210,
        }}
      >
        <Space direction="horizontal" style={{textAlign:"left",padding:"10px 0"}}>
        <HolderOutlined />
        <Breadcrumb >
            {curTitle.map(item => (
            // console.log('111111111111111111111-',item),
              <Breadcrumb.Item key={item} style={{cursor:'pointer',color:'#777'}} >{item}</Breadcrumb.Item>
                
              ))}
          </Breadcrumb>
        </Space>
        <Content
          className="site-layout-background"
          style={{
            padding: 0,
            margin: 0,
            // minHeight: scrheight-60,
          }}
        >
         <div
            className="site-layout-background"
            style={{
              padding: 0,
              textAlign: 'left',fontSize:13
            }}
          >
                <Routes>
                    {
                        getRoutesNodes(menuList)
                    }
                </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  </Layout>

  )
}

export default Admin